module.exports = __webpack_public_path__ + "static/media/boundries79e4754f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/boundries.svg
// module id = 1318
// module chunks = 0